module.exports = __webpack_public_path__ + "img/order-step6-c.031ddef6.png";